import { XMarkIcon } from "@heroicons/react/24/outline"
import React from "react"

import Typography from "../../components/shared/Typography"

import SectionEditForm from "./components/sections/SectionEditForm"
import { useWebsiteBuilderV2 } from "./WebsiteBuilderV2Context"

const EditSectionScreen = ({ onClose }) => {
  const {
    editingSection,
    practice,
    currentPage,
    handleUpdateSection,
    setShowEditSectionScreen,
    setEditingSection,
    clearPreview
  } = useWebsiteBuilderV2()

  const handleSave = async (formData) => {
    try {
      await handleUpdateSection(editingSection.id, formData)
      clearPreview() // Clear preview after successful save
      setShowEditSectionScreen(false)
      setEditingSection(null)
    } catch (error) {
      // Error handling is done in the context
    }
  }

  const handleCancel = () => {
    clearPreview() // Clear any preview changes
    setShowEditSectionScreen(false)
    setEditingSection(null)
    onClose()
  }

  if (!editingSection) {
    return null
  }

  return (
    <div className="flex h-full flex-col bg-white">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-gray-200 p-6">
        <Typography variant="h4" className="text-xl font-semibold">
          {(() => {
            const layout = editingSection.layout
            if (layout === "hero" || layout === "sub_hero") return "Hero"
            if (layout.includes("cta_")) return layout.split("_")[0].toUpperCase() + " " + layout.split("_")[1]
            return layout.charAt(0).toUpperCase() + layout.slice(1)
          })()}
        </Typography>
        <button onClick={handleCancel} className="rounded p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600">
          <XMarkIcon className="h-6 w-6" />
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <SectionEditForm
          section={editingSection}
          sectionType={
            editingSection.layout === "hero" && currentPage?.slug !== "home" ? "sub_hero" : editingSection.layout
          }
          practice={practice}
          onSave={handleSave}
          onCancel={handleCancel}
          isEditing={true}
        />
      </div>
    </div>
  )
}

export default EditSectionScreen
